export default {
  reprintDate: 'RePrint Date',
  printer: 'Printer',
  siteDate: 'Site/Date',
  device: 'Device',
  reprintMethod: 'RePrint Method',
  reprintMethodUpc: 'UPC',
  reprintMethodQr: 'QR'
}
